/* eslint-disable hubspot-dev/no-private-classes */
export const protectedDocs = {};